module.exports = __webpack_public_path__ + "static/media/viewtablespec.1bd8bc02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/viewtablespec.png
// module id = 1859
// module chunks = 193